// extracted by mini-css-extract-plugin
export var container = "_4u-0";
export var infoButton = "_4u-1";
export var label = "_4u-3";
export var labelExpanded = "_4u-4";
export var price = "_4u-5";
export var priceExpanded = "_4u-6";
export var title = "_4u-2";